import { ViteReactSSG } from 'vite-react-ssg'
import './index.css'
import './i18n'
import { routes } from './App'

export const createRoot = ViteReactSSG({ routes })
